export default {
  ru: {
    authorization: 'Авторизация',
    registration: 'Регистрация',
    registrationSuccess: 'Регистрация прошла успешно!',
    restorePassword: 'Восстановление пароля',
    sign_out: 'Выход',
    cardActivation: 'Активация карты',
    congratulations: 'Поздравляем',
    confirm: 'Разрешить приложению использовать вашу учетную запись?',
    baseComponents: 'Базовые компоненты',
    oauth: 'Сервис авторизации',
    cookiePolicy: 'Политика в отношении cookie-файлов',
  },
  en: {
    authorization: 'Authorization',
    registration: 'Registration',
    registrationSuccess: 'Registration completed successfully!',
    restorePassword: 'Restore password',
    sign_out: 'Sign out',
    cardActivation: 'Card Activation',
    congratulations: 'Congratulations',
    confirm: 'Allow application to use your account?',
    baseComponents: 'Base components',
    oauth: 'Authorization service',
    cookiePolicy: 'Cookie policy',
  },
};
